import { useMutation } from 'react-query';
import API from '../api';

import { toast } from 'react-toastify';
import { CreatePopUpForm } from '../types/popupForm';
import { useHistory } from 'react-router-dom';

export const useCreatePopUpForm = () => {
  const { push } = useHistory();

  const { mutateAsync: createPopUpForm } = useMutation(
    (data: CreatePopUpForm) => API.postPopUpForm(data),
    {
      onSuccess: () => {
        toast.success('팝업스토어 문의가 성공적으로 제출되었습니다.');
        push('/popup');
      },
    }
  );
  return {
    createPopUpForm,
  };
};
